<template>
    <Modal v-model="currValue" :title="title" :scrollable="true" width="80%">
        <Spin size="large" fix v-if="loading"></Spin>
        <Form ref="form" :model="formData" :label-width="100">

            <Row>
                <Col span="8">
                    <FormItem label="检测单位" prop="departmentId" :rules="[rules.requiredNumber]">
                        <depart-sel v-model="formData.departmentId" :departmentType="1" width="200px" placeholder="请选择检测单位"></depart-sel>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="环保代码" prop="epNo">
                        <Input v-model="formData.epNo" placeholder="环保代码"></Input>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem label="车牌号" prop="plateNo">
                        <Input v-model="formData.plateNo" placeholder="车牌号"></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>

        <div slot="footer">
            <Button @click="currValue=false">取消</Button>
            <Button type="primary" @click="handleSubmit(1)">通过</Button>
            <Button type="warning" @click="handleSubmit(0)">不通过</Button>
        </div>
    </Modal>
</template>

<script>
    import iEquip from "@/module/main/api/iEquip";
    import DepartSel from '@/module/main/components/DepartSel';
    import modalHelper from "@/mixins/modalHelper";
    import rules from '@/libs/rules';
    import _don from "@/libs/doson";

    const formModal = {
        id:null,
        departmentId:null,
        plateNo:null,
        epNo:null
    };

    export default {
        name: "equip-check",
        mixins: [modalHelper],
        components: {
            DepartSel
        },
        data() {
            return {
                formData: _don.cloneWithModal(formModal),
                title: '档案审核'
            }
        },
        activated() {
            this.init();
        },
        methods: {
            init() {

            },
            setFormData() {
                _don.cloneWithModal(formModal, this.formData, this.dataSource);
                //console.log(this.formData)
            },
            async handleSubmit(type) {
                if(type == 1){
                    if (!this.formData.epNo) {
                        this.$Message.error('请填写环保编号')
                        return
                    }
                    /*if (!this.formData.plateNo) {
                        this.$Message.error('请填写车牌号')
                        return
                    }*/
                    this.formData.status=1
                } else {
                    this.formData.status=2
                }
                // 提交
                iEquip.equipCheck(this.formData).then(() => {
                    this.$Message.success('操作成功');
                    this.$emit('on-success', this.formData);
                    this.currValue = false;
                }).loadingSwitch(this, 'loading');
            },
        },
        computed: {
        },
        watch:{

        }
    }
</script>

<style scoped>
    .form-tip {
        color:#ff0000;
        font-size:14px;
        line-height:28px;
    }
</style>
